import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef } from 'react';

export function ErrorFallback({ message }: { message: string }) {
  const parentRef = useRef<HTMLDivElement>(null);
  return (
    <div className="flex flex-col gap-2 w-full bg-white rounded-md items-center justify-center">
      <div ref={parentRef} className="w-full h-[600px]">
        <div className="flex justify-center items-center h-full">
          <div className="flex flex-col gap-4 items-center justify-center">
            <FontAwesomeIcon
              className="text-primary-red-R500"
              size="3x"
              icon={faCircleExclamation}
            />
            <div className="text-sm text-neutrals-N700">{message}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
